import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/footer/kakao_footer.png'
import _imports_1 from '@/assets/image/icon/line_logo@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-3aeb6836"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  href: "https://pf.kakao.com/_uzWxoxj",
  target: "_blank"
}
const _hoisted_2 = { class: "wrap flex cen ter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "wrap flex cen ter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1
}, null, -1))
const _hoisted_7 = {
  key: 2,
  href: "https://www.skype.com/en/get-skype/",
  target: "_blank"
}
const _hoisted_8 = { class: "wrap flex cen ter" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-s.theckb.com/BusinessMarket/icon/Skype.png"
}, null, -1))

import { t } from '@/plugins/i18n'
import { onMounted, ref } from 'vue'
import { useSite, isJA, isKO, isEN } from '@/store'
import { lineUrl } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['type'],
  setup(__props) {

const locationHref = location.href
const clientHeight = ref(550)

onMounted(async () => {
  if (document.body.clientHeight >= 600) {
    clientHeight.value = document.body.clientHeight
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.type === 'signup' && _unref(isJA)())
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
    : (__props.type === 'signup_h5' && _unref(isJA)())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "contactUS",
          style: _normalizeStyle(clientHeight.value >= 600
      ? ''
      : 'bottom:15vw;right:10px'
    )
        }, [
          (_unref(isKO)())
            ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("span", {
                    class: "text",
                    style: _normalizeStyle(_unref(locationHref).includes('lang=zh') ? 'width:40px' : 'width:50px'
            )
                  }, "Kakao", 4)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _unref(lineUrl),
                target: "_blank"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", {
                    class: "text",
                    style: _normalizeStyle(_unref(locationHref).includes('lang=zh') ? 'width:40px' : 'width:46px'
            )
                  }, _toDisplayString(_unref(t)("联系我们")), 5)
                ])
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_unref(isEN)())
            ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", {
                    class: "text",
                    style: _normalizeStyle(_unref(locationHref).includes('lang=zh') ? 'width:40px' : 'width:46px'
            )
                  }, "Skype", 4)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 4))
}
}

})